// @flow strict

export const DENTAL = 'Dental';
